/**
 * /session-expired — Better Auth session token expired mid-session.
 *
 * Round 5 Item 7 Tier 1 #5. The post-401-redirect destination from
 * apps/ui/src/lib/api/_shared.ts (when an ApiError signals
 * `kind='session_expired'`). Captures the route the user was on as
 * `?return_to=` so we can deep-link back after re-auth.
 *
 * Without this branded surface, an expired session would either silently
 * 401 every endpoint OR send the user to a generic /sign-in screen with
 * no context. The branded fault page tells them what happened in plain
 * English and gives them the right next action.
 */

import { Link, useSearchParams } from 'react-router-dom';

import {
  BrandedFaultRoute,
  FaultCtaHome,
} from '../components/BrandedFaultRoute.tsx';

export function SessionExpired() {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('return_to') ?? '/home';

  // Build /sign-in URL with the return_to threaded through so the existing
  // SignIn next-param handler routes back to where the user was. Strip the
  // leading slash from returnTo via encodeURIComponent for safety.
  const signInHref = `/sign-in?${new URLSearchParams({ next: returnTo }).toString()}`;

  return (
    <BrandedFaultRoute
      kind="warning"
      iconKind="permission-sets"
      eyebrow="Signed out"
      title="Your session timed out."
      body="Sign back in to pick up where you left off. We'll bring you right back here."
      actions={
        <>
          <Link
            to={signInHref}
            className="btn btn-primary btn-sm"
            style={{ textDecoration: 'none' }}
          >
            Sign back in
          </Link>
          <FaultCtaHome label="Back to Home" />
        </>
      }
    />
  );
}
